








































































import List from "@/components/List";
import { CouponResource } from "@/resources";
import { Coupon, Scene } from "@/resources/interfaces";
import Component from "vue-class-component";

@Component
export default class CouponList extends List<Coupon> {
  name = "coupon";
  resource = CouponResource;
  autoCompletes = [{ key: "customerKeyword", minLength: 4 }];
  saveSearchQueryKeys = ["scene"];
  created() {
    this.searchQuery = {
      scene: Scene.PLAY,
      enabled: true,
      ...this.searchQuery
    };
  }
}
